/*--------------------------------------------------------------------------
*  Profile - Show pop-up image on profile dashboard
* -------------------------------------------------------------------------*/
export function handleProfilePopUpImage() {
    const allPopUpBtn = document.querySelectorAll('.pop-up-btn');
    allPopUpBtn.forEach(popUpBtn => {
        // popUpBtn.classList.remove('hidden');
        const popUpModal = popUpBtn.nextElementSibling as HTMLElement;
        const popUpContent = popUpModal.children[0] as HTMLElement;
        const popUpClose = popUpModal.children[0].children[0] as HTMLElement;

        popUpBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            popUpModal.style.display = "flex";
        })
        popUpContent.addEventListener('click', (e) => {
            e.stopPropagation();
            popUpModal.style.display = "flex";
        })
        popUpClose.addEventListener('click', (e) => {
            e.stopPropagation();
            popUpModal.style.display = "none";
        })
        window.addEventListener('click', (e) => {
            e.stopPropagation();
            popUpModal.style.display = "none";
        })
    })
}

/*--------------------------------------------------------------------------
*  Profile - Click upload button to trigger the upload field
* -------------------------------------------------------------------------*/
function updateProfileErrMsg(msg : string) {
    return `<div class="alert alert-danger alert-dismissible fade show" role="alert">${msg}<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">×</span></button></div>`;
}

function validateEmail(email : string) {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
};

export function handleProfileUploadId() {
    const allDashboardContentBlocks = document.querySelectorAll('.dashboard-content-block') as NodeList;
    if (allDashboardContentBlocks) {
        allDashboardContentBlocks.forEach(dashboardContentBlock => {
            // Only run this script in dashboard profile page
            const profilePage = document.querySelector('.fy-profile') as HTMLElement;
            if (!profilePage) {
                return;
            }

            // Elements for cancel change
            const cancelButton = (dashboardContentBlock as HTMLElement).querySelector('.fy-profile-cancel-btn') as HTMLElement;
            const lastNameInput = (dashboardContentBlock as HTMLElement).querySelector('input[name="last_name"]') as HTMLInputElement;
            const firstNameInput = (dashboardContentBlock as HTMLElement).querySelector('input[name="first_name"]') as HTMLInputElement;
            const phoneNumberInput = (dashboardContentBlock as HTMLElement).querySelector('input[name="phone_number"]') as HTMLInputElement;
            const userEmailInput = (dashboardContentBlock as HTMLElement).querySelector('input[name="user_email"]') as HTMLInputElement;
            const userGenderInput = (dashboardContentBlock as HTMLElement).querySelector('select[name="user_gender"]') as HTMLSelectElement;
            const userAgeInput = (dashboardContentBlock as HTMLElement).querySelector('input[name="user_age"]') as HTMLInputElement;
            
            // Initialize elements' value for cancel change
            const lastName = lastNameInput ? lastNameInput.value : '';
            const firstName = firstNameInput ? firstNameInput.value : '';
            const phoneNumber = phoneNumberInput ? phoneNumberInput.value: '';
            const userEmail = userEmailInput ? userEmailInput.value : '';
            const userGender = userGenderInput ? userGenderInput.value : '';

            const userAge = userAgeInput ? userAgeInput.value : '';

            // Event handler for cancel button
            // Only admin's profile page has cancel button
            const adminProfileForm = document.querySelector('.fy-admin-profile') as HTMLFormElement;
            if (adminProfileForm) {
                cancelButton.addEventListener('click', e => {
                    e.preventDefault();
                    e.preventDefault();
                    lastNameInput.value = lastName;
                    firstNameInput.value = firstName;
                    phoneNumberInput.value = phoneNumber;
                    userEmailInput.value = userEmail;
                    userGenderInput.value = userGender;
                    userAgeInput.value = userAge;
                })
            }

            // Javascript validation for update user info
            const updateButton = (dashboardContentBlock as HTMLElement).querySelector('.houzez_update_profile') as HTMLElement;
            const notify = (dashboardContentBlock as HTMLElement).querySelector('.notify') as HTMLElement;
            if (adminProfileForm) {
                updateButton.addEventListener('click', e => {
                    e.preventDefault();
                    
                    notify.innerHTML = '';
                    if (lastNameInput.value.trim() == '') {
                        notify.innerHTML = updateProfileErrMsg('姓氏不能為空白');
                    } else if (firstNameInput.value.trim() == '') {
                        notify.innerHTML = updateProfileErrMsg('名字不能為空白');
                    } else if (phoneNumberInput.value.trim() == '') {
                        notify.innerHTML = updateProfileErrMsg('手提電話不能為空白');
                    } else if (isNaN(Number(phoneNumberInput.value.trim()))) {
                        notify.innerHTML = updateProfileErrMsg('請輸入有效的8位數字電話號碼');
                    } else if (phoneNumberInput.value.trim().length !== 8) {
                        notify.innerHTML = updateProfileErrMsg('請輸入有效的8位數字電話號碼');
                    } else if (!validateEmail(userEmailInput.value.trim())) {
                        notify.innerHTML = updateProfileErrMsg('請輸入有效電郵地址');
                    } else if (!(userGenderInput.value.trim() == "M" || userGenderInput.value.trim() == "F" || userGenderInput.value.trim() == "N/A")) {
                        notify.innerHTML = updateProfileErrMsg('請輸入有效性別');
                    // } else if (userAgeInput.value.trim() == '') {
                    //     notify.innerHTML = updateProfileErrMsg('年齡不能為空白!');
                    }else if (userAgeInput.value.trim() !== '' && isNaN(Number(userAgeInput.value.trim()))) {
                        notify.innerHTML = updateProfileErrMsg('年齡需為有效數字');
                    }
                })
            }
        })
    }
}

/*--------------------------------------------------------------------------
 * Function copy from patent theme, for handling ajax profile update.
 * -------------------------------------------------------------------------*/
export function handleProfileUpdate() {
    var ajaxurl = (window as any).houzez_vars.admin_url+ 'admin-ajax.php';
    // var gdpr_agree_text = 'Please Agree GDPR';
    
    jQuery(".houzez_update_profile").on('click', function(e) {
        e.preventDefault();

        var $this = jQuery(this);
        var $form = $this.parents( 'form' );
        const form = $form[0];
        var $block = $this.parents( '.dashboard-content-block' );
        var $result = $block.find('.notify');
        const $popUpModalImg = $block.find('img');

        // var description = tinyMCE.get('about').getContent();
        
        // var gdpr_agreement;

        // if(jQuery('#gdpr_agreement').length > 0 ) {
        //     if(!jQuery('#gdpr_agreement').is(":checked")) {
        //         jQuery('#profile_message').empty().append('<div class="alert alert-danger alert-dismissible" role="alert"><button type="button" class="close" data-hide="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>'+gdpr_agree_text+'</div>');
        //         jQuery(".dashboard-content-area").animate({ scrollTop: 0 }, "slow");
        //         return false;
        //     } else {
        //         gdpr_agreement = 'checked';
        //     }
        // } 

        let data = new FormData(form); //Use formData method to handle file uploaded by form.

        jQuery.ajax({
            url: ajaxurl,
            data: data,
            method: $form.attr('method'),
            dataType: "JSON",
            contentType: false,
            processData: false,

            beforeSend: function( ) {
                $this.find('.houzez-loader-js').addClass('loader-show');
            },
            success: function(data : any) { 
                if( data.success ) {
                    $result.empty().append('<div class="alert alert-success alert-dismissible fade show" role="alert">'+data.msg+'<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');

                    const allDashboardContentBlocks = document.querySelectorAll('.dashboard-content-block') as NodeList;
                    if (allDashboardContentBlocks) {
                        allDashboardContentBlocks.forEach(dashboardContentBlock => {
                            // Elements for cancel change
                            const cancelButton = (dashboardContentBlock as HTMLElement).querySelector('.fy-profile-cancel-btn') as HTMLElement;
                            const lastNameInput = (dashboardContentBlock as HTMLElement).querySelector('input[name="last_name"]') as HTMLInputElement;
                            const firstNameInput = (dashboardContentBlock as HTMLElement).querySelector('input[name="first_name"]') as HTMLInputElement;
                            const phoneNumberInput = (dashboardContentBlock as HTMLElement).querySelector('input[name="phone_number"]') as HTMLInputElement;
                            const userEmailInput = (dashboardContentBlock as HTMLElement).querySelector('input[name="user_email"]') as HTMLInputElement;
                            const userGenderInput = (dashboardContentBlock as HTMLElement).querySelector('select[name="user_gender"]') as HTMLSelectElement;
                            const userAgeInput = (dashboardContentBlock as HTMLElement).querySelector('input[name="user_age"]') as HTMLInputElement;
                            
                            // Initialize elements' value for cancel change
                            const lastName = lastNameInput.value;
                            const firstName = firstNameInput.value;
                            const phoneNumber = phoneNumberInput.value;
                            const userEmail = userEmailInput.value;
                            const userGender = userGenderInput.value;
                            const userAge = userAgeInput.value;

                            // Element for update profile title
                            const profileTitleField = (dashboardContentBlock as HTMLElement).querySelector('.profile-title') as HTMLElement;

                            // Update the profile's title after successfully update user info
                            profileTitleField.innerText = /^[a-zA-Z]+$/.test(lastName) ? `${lastName} ${firstName}` : `${lastName}${firstName}`;

                            // Event handler for cancel button
                            cancelButton.removeEventListener("click", e => {
                                e.preventDefault();
                                e.preventDefault();
                                lastNameInput.value = lastName;
                                firstNameInput.value = firstName;
                                phoneNumberInput.value = phoneNumber;
                                userEmailInput.value = userEmail;
                                userGenderInput.value = userGender;
                                userAgeInput.value = userAge;
                            });
                            cancelButton.addEventListener('click', e => {
                                e.preventDefault();
                                e.preventDefault();
                                lastNameInput.value = lastName;
                                firstNameInput.value = firstName;
                                phoneNumberInput.value = phoneNumber;
                                userEmailInput.value = userEmail;
                                userGenderInput.value = userGender;
                                userAgeInput.value = userAge;
                            })
                        })
                    }
                    if (data.base64) {
                        $popUpModalImg.attr('src', data.base64);
                    }
                } else {
                    $result.empty().append('<div class="alert alert-danger alert-dismissible fade show" role="alert">'+data.msg+'<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
                }
            },
            error: function(errorThrown) {

            },
            complete: function(){
                $this.find('.houzez-loader-js').removeClass('loader-show');
            }
        });
    });
}

/*--------------------------------------------------------------------------
 * Function copy from patent theme, for handling ajax profile delete. (Delete user account)
 * -------------------------------------------------------------------------*/
var profile_processing_modal = function ( msg : string ) {
    var process_modal ='<div class="modal fade" id="fave_modal" tabindex="-1" role="dialog" aria-labelledby="faveModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-body houzez_messages_modal">'+msg+'</div></div></div></div></div>';
    jQuery('body').append(process_modal);
    (jQuery('#fave_modal') as any).modal();
}

var profile_processing_modal_close = function ( ) {
    (jQuery('#fave_modal') as any).modal('hide');
}

export function handleProfileDelete() {
    var ajaxurl = (window as any).houzez_vars.admin_url+ 'admin-ajax.php';
    var processing_text = '請在處理中，請稍後...';

    jQuery('.houzez_delete_account').on('click', function(e){
        e.preventDefault();
        const user_id = this.getAttribute( "id" );
        console.log('delete');
        console.log(processing_text);

        var confirm = window.confirm("確定刪除此帳戶嗎?");

        if ( confirm == true ) {

            jQuery.ajax({
                type: 'post',
                url: ajaxurl,
                dataType: 'json',
                data: {
                    'action': 'houzez_delete_account',
                    'user_id': user_id,
                },
                beforeSend: function () {
                    profile_processing_modal(processing_text);
                },
                success: function( response ) {
                    if( response.success ) {
                        // window.location.href = houzez_site_url;
                        window.alert('帳戶已刪除');
                        location.reload();
                        // TODO: Should redirect to a better location
                    } else {
                        window.alert('沒有權限刪除此帳戶');
                        location.reload();
                    }
                },
                error: function(xhr, status, error) {
                    var err = eval("(" + xhr.responseText + ")");
                    console.log(err.Message);
                }
            });

        }
    });
}